import { render, staticRenderFns } from "./MoreInfoTable.vue?vue&type=template&id=c87a3f86"
import script from "./MoreInfoTable.vue?vue&type=script&lang=js"
export * from "./MoreInfoTable.vue?vue&type=script&lang=js"
import style0 from "./MoreInfoTable.vue?vue&type=style&index=0&id=c87a3f86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports